import React from 'react';
import {Helmet} from "react-helmet";
import './HostSignup.css'
import "bootstrap/dist/css/bootstrap.min.css";
import HostForm from '../HostForm/Index';
import HeaderHostsignup from './HeaderHostsignup/HeaderHostsignup';
import { Link } from 'react-router-dom';

const HostSignup = () => {

    const handleContinueToBeta = () => {
        setTimeout(() => {
          const modal = new window.bootstrap.Modal(document.getElementById('exampleModal1'));
          modal.show(); 
        }, ); 
      };

  return (
    <>
      <Helmet>
        <title>Sign Up as a Host | RentId - The Only Car Rental Platform You Need</title>
        <meta property="og:title" content="Sign Up as a Host | RentId - The Only Car Rental Platform You Need" />
        <meta name="twitter:title" content="Sign Up as a Host | RentId - The Only Car Rental Platform You Need" />
        <meta name="description" content="Join RentId as a host and start renting out your vehicles. Create an account, manage your rental settings, and list your cars with ease." />
        <meta name="twitter:description" content="Become a RentId host and start your car rental journey. Set up your account, manage settings, and list vehicles effortlessly." />
        <meta property="og:description" content="Become a RentId host and start your car rental journey. Set up your account, manage settings, and list vehicles effortlessly." />
        <meta name="keywords" content="RentId host sign up, car rental platform, rent out vehicles, car sharing, host registration" />
        <meta property="og:url" content="https://www.rentid.io/host-signup" />
        <link rel="canonical" href="https://www.rentid.io/host-signup" />
      </Helmet>
    <HeaderHostsignup/>
    <div className="welcomeMain">
        <div className="container">
          <div className="row justify-content-between">
              <div className="col-lg-6 col-md-6">
                  <div className="welcomeLeft">
                      <h2><span>Welcome to</span> <img className="img-fluid" src="/img/logo_signup.svg" alt="logo"/></h2>
                      <p>The only car rental platform you’ll ever need.</p>
                      <img className="img-fluid image_signup" src="/img/image_signup.png" alt="Signup Icon"/>
                  </div>
              </div>
              <div className="col-lg-5 col-md-6">
                  <div className="welcomeRight">
                    <ul>
                        <li>
                          <h3>Create an account</h3>
                          <p>Provide your information to sign up.</p>
                        </li>
                        <li>
                          <h3>Manage your settings</h3>
                          <p>We're going to ask questions about your operations and the rental processes.</p>
                        </li>
                        <li>
                          <h3>Start renting!</h3>
                          <p>Add vehicle details, pictures and pricing for one or multiple vehicles. </p>
                        </li>
                    </ul>
                    
                  </div>
              </div>
          </div>
        </div>
    </div>


    <div className="footerCustom">
          <div className="container">
                <div className="row align-items-center">
                        <div className="col-lg-12 col-md-12">
                            <div className="footerCustomInner">
                                  <div className="skipFooter">
                                      <Link href="#">Skip</Link> 
                                  </div> 
                                  <div className="getFooter">
                                      <button
                                          type="button"
                                          className="btn btn-radius"
                                          onClick={handleContinueToBeta}
                                        >
                                          Get Started
                                      </button> 
                                  </div> 
                            </div> 
                        </div>
                  </div>
            </div>
      </div>
    <HostForm/>
    </>
  );
};

export default HostSignup;
